import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useLazyQuery } from "@apollo/client";

import { Form, Input } from "antd";
import { SyncOutlined } from "@ant-design/icons";

import { QUERY_STUDENT_PARENT2_PRIMARY_LANGUAGE } from "../../../../operations/queries/forms/SIS";
import SyncSISButton from "../../../elements/formItems/SyncSISButton";

const StudentParent2LanguageSIS = ({
  form,
  sis,
  id,
  initialValue,
  error,
  disabled = true,
}) => {
  const [studentSIS, setStudentSIS] = useState(initialValue);
  const [getSIS, { data, loading }] = useLazyQuery(QUERY_STUDENT_PARENT2_PRIMARY_LANGUAGE);
  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      parent2PrimaryLanguage: data?.student.parent2PrimaryLanguage || "",
    });
    setStudentSIS(data.student.parent2PrimaryLanguage || "");
  }, [data]);

  return (
    <Form.Item
      label="Parent #2 Language"
      name="parent2PrimaryLanguage"
      validateStatus={error ? "error" : ""}
      help={error}
    >
      <Input
        onChange={(e) => setStudentSIS(e.target.value)}
        disabled={disabled}
        addonAfter={
          <SyncSISButton
            loading={loading}
            sisValue={sis?.student.parent2PrimaryLanguage}
            currentValue={studentSIS}
          >
            <SyncOutlined onClick={() => getSIS({ variables: { id: id } })} />
          </SyncSISButton>
        }
      />
    </Form.Item>
  );
};


StudentParent2LanguageSIS.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.string.isRequired,
  sis: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default StudentParent2LanguageSIS;
